/*
The MIT License (MIT)

Copyright (c) 2015 Kenneth Chung

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// Scaricata da:
// https://github.com/CaptEmulation/react-click-outside
// più modifiche per import ed export

import React, { Component } from 'react'
import ReactDOM from 'react-dom'

function isPrototypeOf(actual, expected) {
  let expectedIsAPrototypeOfActual = actual === expected
  // Walk prototype chain
  let ip = actual
  while (ip && ip.prototype && !expectedIsAPrototypeOfActual) {
    expectedIsAPrototypeOfActual = ip === expected
    ip = ip.prototype
  }
  return expectedIsAPrototypeOfActual
}

function ReactClickOutside(unknown) {
  const { event = 'click' } = unknown || {}

  function decorator(WrappedComponent) {
    const componentName = WrappedComponent.displayName || WrappedComponent.name

    class EnhancedComponent extends React.Component {
      constructor(props) {
        super(props)
        this.handleClickOutside = this.handleClickOutside.bind(this)
      }

      componentDidMount() {
        document.addEventListener(event, this.handleClickOutside, true)
      }

      componentWillUnmount() {
        document.removeEventListener(event, this.handleClickOutside, true)
      }

      handleClickOutside(e) {
        const domNode = this.__domNode
        if (
          (!domNode || !domNode.contains(e.target)) &&
          typeof this.__wrappedInstance.handleClickOutside === 'function'
        ) {
          this.__wrappedInstance.handleClickOutside(e)
        }
      }

      render() {
        const { wrappedRef, ...rest } = this.props

        return (
          <WrappedComponent
            {...rest}
            ref={(c) => {
              this.__wrappedInstance = c
              this.__domNode = ReactDOM.findDOMNode(c)
              wrappedRef && wrappedRef(c)
            }}
          />
        )
      }
    }

    EnhancedComponent.displayName = `clickOutside(${componentName})`

    return EnhancedComponent
  }

  if (isPrototypeOf(unknown, Component) || typeof unknown === 'function') {
    // Is a react class or a function which is potentially a react render function
    return decorator(unknown)
  }
  return decorator
}

export default ReactClickOutside



// WEBPACK FOOTER //
// ./src/lib/react-click-outside.js